<style scoped>
</style>

<template>
  <Select v-model="value" @on-change="onChange">
    <Option
      v-for="item in dictItem"
      :value="item.itemvalue"
      :key="item.itemvalue"
    >{{ item.itemtext }}</Option>
  </Select>
</template>

<script>
export default {
  props: ["dictcode", "value"],
  data() {
    return {
      dictItem: []
    };
  },
  methods: {
    onChange() {
      this.$emit("input", this.value);
    }
  },
  mounted() {
    let _this = this;
    this.$http.get({
      method: "base/dictitem/listbydictcode",
      params: {
        dictcode: this.dictcode
      },
      success: function(data) {
        _this.dictItem = data;
      }
    });
  }
};
</script>